//@flow
import React, { Component } from "react";
import "./postcode-update.scss";

type Props = {
  onPostcodeUpdate: () => Promise<any>,
  onPostcodeClose: () => void
};

class PostcodeUpdate extends Component<Props> {
  postCodeUpdateElement: any;

  constructor(props: Props) {
    super(props);
    this.postCodeUpdateElement = React.createRef();
  }

  handlePostCodeUpdate = () => {
    this.props.onPostcodeUpdate();
  };

  triggerPostcodeUpdate = () => {
    this.postCodeUpdateElement.current.triggerPostcodeUpdate();
  };

  componentDidMount() {
    this.postCodeUpdateElement.current.addEventListener(
      "postcode-update__postcode-updated",
      this.handlePostCodeUpdate
    );
  }

  componentWillUnmount() {
    this.postCodeUpdateElement.current.removeEventListener(
      "postcode-update__postcode-updated",
      this.handlePostCodeUpdate
    );
  }

  render() {
    return (
      <div className="popup-postcode-wrapper">
        <a
          className="popup-postcode-close"
          onClick={this.props.onPostcodeClose}
        />
        <div className="popup-postcode">
          <div className="popup-postcode__form">
            <div className="popup-postcode__form-row">
              <label className="popup-postcode__label" htmlFor="postcode">
                Enter your postcode to see pricing
              </label>
            </div>
            <div className="popup-postcode__form-row">
              <div className="popup-postcode__search-input-container store-finder-container">
                <postcode-update
                  ref={this.postCodeUpdateElement}
                  input-class="popup-postcode__input"
                  placeholder="Type in postcode..."
                  error-class="form-control-error-message"
                />
              </div>
            </div>
            <div className="popup-postcode__form-row">
              <button
                className="popup-postcode__button"
                onClick={this.triggerPostcodeUpdate}
              >
                Set As My Location
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default PostcodeUpdate;
